



export function cloneArray(source) {
	let result = [];
	for(let n = 0; n < source.length; n++) {
		result[n] = source[n];
	}
	return result;
}


// WEBPACK FOOTER //
// ./src/utils/data.jsx